module.exports = __webpack_public_path__ + "static/user1-583aae6ee13e3e467de6f0da94af921e.jpg";